import "./CantFindAnswer.css";

export default function CantFindAnswer() {
  return (
    <section id="cant_find_answer">
      <div className="container">
        <h3 className="text-dark">Can’t Find the Answer? Contact Us</h3>
        <h2 className="h2-big ">
          <a href="mailto:support@essy.com" className="text-dark">
            Support@essy.com
          </a>
        </h2>
      </div>
    </section>
  );
}
